import React from 'react';
import { connect, ConnectedProps } from 'react-redux';
import { selectLocale } from './LanguageProvider.selectors';
import { RootState } from '../../app/store';
import { FunctionComponent } from 'react';
import { IntlProvider } from 'react-intl';
import messages from '../../i18n';


const connector = connect((state: RootState) => ({
  locale: selectLocale(state),
}));

type PropsFromRedux = ConnectedProps<typeof connector>;

const LanguageProvider: FunctionComponent<PropsFromRedux> = ({
  locale,
  children,
}) => {
  return (
    <IntlProvider locale={locale} key={locale} messages={messages[locale]}>
      {React.Children.only(children)}
    </IntlProvider>
  );
};

export default connector(LanguageProvider);
